import React from 'react'
import { Form, Modal } from 'react-bootstrap'
import '../../../CommonCss/ModalCommonCss.css'
import DownloadPaymentSlip from '../animation/DownloadPaymentSlip.js'



const PaymentSlipDeleteModal = (props) => {
    return (
        <section className='modal-common-class-hrms'>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="add-modal"
            >
                <Modal.Body>
                    <div className='below-bodyy'>
                        <div className='donwload-div d-flex justify-content-center'>
                            <DownloadPaymentSlip/>
                            <h6 className='mt-2'>Payment Slip Downloaded Successfully!</h6>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </section>
    )
}

export default PaymentSlipDeleteModal